import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { DFPSlotsProvider, AdSlot } from 'react-dfp/js';
import breakpoints from '../Theme/breakpoints';

export const SideBarAdUnitContainer = styled.div`
  display: none;

  @media (min-width: ${breakpoints.xssm}px) {
    display: block;
  }
`;

const AdUnitContainer = styled.div`
  ${({ noBackground }) => (noBackground ? '' : 'background-color: #f8f8f8;')}
  min-height: ${(properties) => properties.minHeight};
  border: 1px solid var(--grey-light);
  text-align: center;
  text-align: -webkit-center;
  padding: 24px 0;

  @media (min-width: ${breakpoints.sm}px) {
    border: none;
  }

  @media (min-width: ${breakpoints.md}px) {
    padding: 16px 0;
  }

  iframe {
    display: block;
    margin: 0 auto;
  }
`;

AdUnitContainer.propTypes = {
  /** Sets the min height to minimize reflow */
  minHeight: PropTypes.string.isRequired,
};

const AdUnit = ({
  dfpNetworkId,
  adUnit,
  sizes,
  minHeight,
  noBackground,
}) => (
  <AdUnitContainer
    minHeight={minHeight}
    noBackground={noBackground}
  >
    <DFPSlotsProvider
      dfpNetworkId={dfpNetworkId}
      adUnit={adUnit}
    >
      <AdSlot sizes={sizes} />
    </DFPSlotsProvider>
  </AdUnitContainer>
);

AdUnit.propTypes = {
  /** ID to configure dfp */
  dfpNetworkId: PropTypes.string.isRequired,
  /** Ad unit path */
  adUnit: PropTypes.string.isRequired,
  /** Sizes for the ad image */
  sizes: PropTypes.arrayOf(PropTypes.node),
  /** Sets the min height to minimize reflow */
  minHeight: PropTypes.string,
  /** Removes grey background around ad */
  noBackground: PropTypes.bool,
};

AdUnit.defaultProps = {
  sizes: [],
  minHeight: '50px',
  noBackground: false,
};

export default AdUnit;
